import { getInternalKeyForFavouriteDescriptor } from '../util.get-internal-key.js';

function selectFullDescriptor(partialDescriptor) {
  return descriptors => descriptors?.find(it => getInternalKeyForFavouriteDescriptor(it) === getInternalKeyForFavouriteDescriptor(partialDescriptor)) ?? partialDescriptor;
}

export { selectFullDescriptor };
//# sourceMappingURL=selector.full-descriptor.js.map
